import { BaseModel, type RelationConfig } from './base';
import { ContentTemplate } from './contentTemplate';

export class ServiceAutomation extends BaseModel {
  id!: number;
  idServiceAutomation!: number;
  idContentTemplate?: number;
  scheduleOffset!: number;
  type!: ServiceAutomationType;
  frequency!: ServiceAutomationFrequency;
  requirementMode!: ServiceAutomationRequirementMode;
  enabled!: boolean;
  channels!: string[];
  availableChannels?: string[];

  contentTemplate?: ContentTemplate;

  static override relations(): RelationConfig {
    return {
      contentTemplate: { type: ContentTemplate },
    };
  }

  override objectID(): string {
    return this.idServiceAutomation?.toString() || '';
  }

  get scheduleOffsetMode(): 'before' | 'after' {
    return this.scheduleOffset > -1 ? 'after' : 'before';
  }

  set scheduleOffsetMode(value: 'before' | 'after') {
    const isBefore = value === 'before';

    if (isBefore) {
      this.scheduleOffset = -Math.abs(this.scheduleOffset);
    } else {
      this.scheduleOffset = Math.abs(this.scheduleOffset);
    }
  }

  get scheduleOffsetValue(): number {
    return Math.abs(this.scheduleOffset);
  }

  set scheduleOffsetValue(value: number) {
    const isBefore = this.scheduleOffsetMode === 'before';

    if (isBefore) {
      this.scheduleOffset = -Math.abs(value);
    } else {
      this.scheduleOffset = Math.abs(value);
    }
  }

  get isRequirementModeScheduled(): boolean {
    return this.requirementMode === ServiceAutomationRequirementMode.scheduled;
  }

  get name(): string {
    return this.contentTemplate?.name || '';
  }
}

export enum ServiceAutomationType {
  message = 1,
}

export const ServiceAutomationTypeLabels: Record<ServiceAutomationType, string> = {
  [ServiceAutomationType.message]: 'general.message',
};

export enum ServiceAutomationFrequency {
  reservation = 0,
  customer = 1,
  service = 2,
}

export const ServiceAutomationFrequencyLabels: Record<ServiceAutomationFrequency, string> = {
  [ServiceAutomationFrequency.reservation]: 'service.form.frequency.reservation',
  [ServiceAutomationFrequency.customer]: 'service.form.frequency.customer',
  [ServiceAutomationFrequency.service]: 'service.form.frequency.service',
};

export enum ServiceAutomationRequirementMode {
  confirmation = 0,
  scheduled = 1,
  internal = 2,
}

export const ServiceAutomationRequirementModeLabels: Record<ServiceAutomationRequirementMode, string> = {
  [ServiceAutomationRequirementMode.confirmation]: 'service.form.requirement.confirmation',
  [ServiceAutomationRequirementMode.scheduled]: 'service.form.requirement.scheduled',
  [ServiceAutomationRequirementMode.internal]: 'service.form.requirement.internal',
};